export default "__VITE_ASSET__7XAiW06b__"